export const activityPath = '/chart/:patientId/activity/:studyPk/:activitySk/:eventSk/:activityInstanceId?';
